/**
 * Modal component for confirming course-wide preview
 */

import React from 'react'
import { Modal, Button } from 'antd'
import { useTranslation } from 'react-i18next'

const ApplyAllConfirmModal = ({
  visible,
  onCancel,
  onConfirm,
  instructions,
  isApplyingAll
}) => {
  const { t } = useTranslation()
  return (
    <Modal
      title={t('v4:confirm_course_wide_premiew')}
      visible={visible}
      onCancel={onCancel}
      centered
      className="ai-apply-all-confirm"
      footer={[
        <Button
          key="cancel"
          onClick={onCancel}
          className="shl-secondary-btn"
          size="small"
        >
          {t('buttons:cancel')}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          onClick={onConfirm}
          className="shl-primary-btn"
          loading={isApplyingAll}
          size="small"
        >
          {t('v4:generate_course_preview')}
        </Button>
      ]}
    >
      <div className="ai-apply-all-confirm-inner">
        <p>{t('v4:instructions_across_the_course_to_generate')}</p>
        {instructions ? (
          <div
            style={{
              marginTop: 12,
              padding: 12,
              border: '1px solid #d9d9d9',
              borderRadius: 6,
              backgroundColor: '#fafafa'
            }}
          >
            <strong>{t('v4:instruction_to_preview_course_wide')}</strong>
            <div style={{ marginTop: 8 }}>{instructions}</div>
          </div>
        ) : null}
      </div>
    </Modal>
  )
}

export default ApplyAllConfirmModal
